import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IMaintenance } from '../../models/general.model';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceApiService {
  constructor(private http: HttpClient) {}

  getMaintenanceStatus(tenantId: string): Observable<IMaintenance> {
    return this.http.get<IMaintenance>(
      `${environment.apiURL}/tenants/${tenantId}/getMaintenanceStatus`
    );
  }
}
